import type { TrainTranslations } from "./trainTranslations.types";

const trainUkTranslations: TrainTranslations = {
    trainPage: {
        title: "Train",
        step: "Step",
        resultsFound: "train options found",
        stopOver: "Stop",
        stopOverPlural: "Stops",
        nextStep: "Next step",
        loadingTimeline: "Loading timetable…",
    },
    trainSortBy: {
        title: "Sort by",
        price_asc: "Lowest price first",
        price_desc: "Highest price first",
        fastest: "Fastest",
        fewest_changes: "Fewest changes"
    },
    trainBlock: {
        title: "Train Service",
        direct: "Direct"
    },
    trainFilters: {
        outboundTrip: {
            title: "Outbound train times",
            duration: "Duration",
            departure: {
                location: "",
                time: "Departure"
            },
            arrival: {
                location: "Destination station",
                time: "Arrival"
            }
        },
        inboundTrip: {
            title: "Inbound train times",
            duration: "Duration",
            departure: {
                location: "",
                time: "Departure"
            },
            arrival: {
                location: "",
                time: "Arrival"
            }
        },
        operators: "Operator",
        duration: "Journey duration"
    },
    stationsNames: {
        STP: "London St Pancras",
        EBB: "Ebbsfleet International",
        AFI: "Ashford International",
        CMF: "Chambéry-Savoie",
        XAP: "Aime La Plagne",
        XBM: "Bourg St Maurice",
        XBMA: "Bourg St Maurice",
        XAV: "Albertville",
        XMO: "Moutiers",
        XDB: "Lille Europe",
        PLY: "Paris - Gare de Lyon",
        PAZ: "Paris Gare d’Austerlitz",
        PEST: "Paris - Gare de l'Est",
        PARIS: "Paris - Gare de Lyon",
        AMS: "Amsterdam Centraal",
        RTM: "Rotterdam Centraal",
        ANR: "Antwerp",
        BRU: "Brussels Midi",
        "Bourg-Saint-Maurice": "Bourg Saint Maurice",
        "Aime-la-Plagne": "Aime la Plagne",
        "Moûtiers": "Moûtiers",
    },
    operatorsNames: {
        ES: "Eurostar",
        "9F": "Eurostar",
        PEG: "Pegasus Train",
        PEGASUS: "Pegasus Train"
    },
    trainClass: {
        standard: "Eurostar Standard",
        premium: "Eurostar Plus",
        title: "Travel classes",
        outOfStock: "Out of stock"
    },
    trainClassCard: {
        yourTrain: "Your train",
        travelClass: "Your travel class",
        details: "Details",
        from: "From",
        included: "Included",
        select: "Select",
        classes: {
            seat: {
                title: "Seated places",
                description: "The perfect seat for a budget-friendly trip.",
            },
            standard: {
                title: "Standard",
                description: "Standard couchette with the essentials for your journey.",
            },
            standardPlus: {
                title: "Standard Plus",
                description: "A comfortable couchette for a pleasant journey.",
            },
            premiere: {
                title: "First Class",
                description: "The premium travel option for travellers seeking comfort.",
            },
        },
        criteria: {
            compartment6: "6-person compartment",
            compartment3: "3-person compartment",
            nonRecliningSeats: "Non-reclining seats",
            electricalOutlet: "Electrical outlet",
            breakfastOptional: "Breakfast optional",
            sleepingBagSheet: "Sleeping bag sheet, pillowcase and blanket provided",
            storageSpace: "Storage space",
            comfortMattress: "Comfortable mattress topper",
            sheetDuvetPillow: "Sheet, duvet and pillowcase provided",
            storageNet: "Storage net",
            blackoutBlind: "Blackout blind",
            realBeds: "Real beds with sheet, duvet and pillowcase.",
            premiumBedding: "Premium bedding",
            loungeSeats3: "3 seats",
            connectingCompartments: "Connecting compartments available",
            privateSink: "Private sink",
            largeStorage: "Large storage space",
        },
        subOptions: {
            individualBerths: {
                title: "2 individual berths",
                description: "Enjoy a unique experience travelling in a shared 6-person cabin.",
            },
            privateCompartment: {
                title: "Private 6-person compartment",
                description: "Book an entire compartment, alone or with others, for your trip with family or friends.",
            },
        },
        modal: {
            serviceTitle: "Service",
            services: {
                seat: {
                    breakfastOptional: "Breakfast optional",
                },
                standard: {
                    breakfastOptional: "Breakfast optional",
                },
                standardPlus: {
                    breakfastOptional: "Breakfast optional",
                    comfortKit: "Comfort kits: mattress topper + duvet (€5.50/person)",
                },
                premiere: {
                    breakfastOptional: "Breakfast optional",
                },
            },
        },
    }
};

export default trainUkTranslations;
